import React, { useEffect } from "react";
import styled from "styled-components";
import { ReactComponent as ProfileSvg } from "../images/profile.svg";
import { Link } from "react-router-dom";

import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import TopBanner from "../components/TopBanner";

const Home = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const constainerVariant = {
    hidden: {
      scaleX: 0,
    },
    visible: {
      scaleX: 1,
      transition: { type: "spring", stiffness: 50 },
    },
    exit: {
      scaleX: 0,
      transition: { ease: "easeInOut" },
    },
  };

  return (
    <>
      <Container
        as={motion.main}
        variants={constainerVariant}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <TopBanner
          loaction1={"Currently"}
          location2={"Frontend Developer"}
          place1={"Based in Abuja"}
          place2={"Nigeria"}
        />

        <HomeHero data-aos="fade-up">
          <h2>
            frontend <br /> developer
          </h2>
          <ImageContainer data-aos="fade-up">
            <ImageDiv>
              <ProfileSvg />
            </ImageDiv>
          </ImageContainer>

          <NameHolder data-aos="fade-up">
            <Link to="/about" style={{ textDecoration: "none" }}>
              <h2>Damian Aluku</h2>
            </Link>
          </NameHolder>
        </HomeHero>
      </Container>
    </>
  );
};

export default Home;

const Container = styled.main`
  width: 100%;
  min-height: 100vh;
`;

const HomeHero = styled.section`
  margin: 0 0 8rem 0;

  h2 {
    width: 100%;
    font-size: 60px;
    text-transform: uppercase;
    letter-spacing: 5px;
    text-align: center;
  }

  @media screen and (max-width: 760px) {
    h2 {
      font-size: 40px;
      margin-left: 0;
    }
  } ;
`;

const ImageContainer = styled.div`
  padding: 1rem 0;
  margin-left: 2rem;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 760px) {
    padding: 1rem 0 0;
    margin-left: 0;
  } ;
`;
const ImageDiv = styled.div`
  width: 450px;
  height: 450px;

  svg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  @media screen and (max-width: 760px) {
    width: 250px;
    height: 250px;
    margin: 2rem 0;
  } ;
`;

const NameHolder = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h4 {
    line-height: 2rem;
    font-size: 22px;
    font-weight: normal;
  }

  @media screen and (max-width: 760px) {
    h2 {
      font-size: 40px;
    }
    h4 {
      line-height: 2rem;
      text-align: center;
      margin-top: 1rem;
    }

    svg {
      grid-area: 1/5/3/7;
      justify-self: center;
      align-self: center;
    }
  } ;
`;
